import { motion } from "framer-motion";

export default function About() {
  return (
    <section className="bg-ivory dark:bg-charcoal transition-colors">

      {/* Hero */}
      <div
        className="h-[60vh] bg-cover bg-center"
        style={{ backgroundImage: "url('/assets/images/hero.jpg')" }}
      >
        <div className="h-full bg-black/40 flex items-center justify-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-5xl font-serif text-gold"
          >
            Our Story
          </motion.h1>
        </div>
      </div>

      {/* Story */}
      <div className="max-w-5xl mx-auto px-6 py-24">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-lg text-charcoal/80 dark:text-ivory/80 leading-relaxed"
        >
          M R Suites Dharwad is a refined expression of timeless hospitality,
          thoughtfully crafted for travellers who value comfort, elegance,
          and meaningful experiences. Rooted in tradition and shaped by
          modern sensibilities, our lodge reflects a balance between warmth
          and sophistication.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="mt-8 text-lg text-charcoal/80 dark:text-ivory/80 leading-relaxed"
        >
          Located in the heart of Dharwad, M R Suites offers a serene
          retreat from the bustle of everyday life while ensuring seamless
          access to the city’s cultural and business hubs. Every space has
          been designed with attention to detail, offering guests a calm,
          welcoming atmosphere that feels both intimate and distinguished.
        </motion.p>
      </div>

      {/* Values */}
      <div className="bg-white dark:bg-[#1a1a1a] py-24">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-12">

          {[
            {
              title: "Timeless Hospitality",
              text: "Service that is gracious, attentive, and deeply respectful of every guest."
            },
            {
              title: "Refined Comfort",
              text: "Spaces designed to offer quiet luxury without excess."
            },
            {
              title: "Thoughtful Living",
              text: "An environment that encourages rest, reflection, and balance."
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <h3 className="text-2xl font-serif text-gold">
                {item.title}
              </h3>
              <p className="mt-4 text-charcoal/70 dark:text-ivory/70">
                {item.text}
              </p>
            </motion.div>
          ))}

        </div>
      </div>

      {/* Why Choose Us */}
      <div className="max-w-5xl mx-auto px-6 py-24 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-4xl font-serif text-gold"
        >
          Why Choose M R Suites Dharwad
        </motion.h2>

        <p className="mt-6 text-lg text-charcoal/80 dark:text-ivory/80 leading-relaxed">
          Because true luxury lies not in extravagance, but in thoughtful
          details, warm hospitality, and an atmosphere that feels like home
          — refined, calm, and enduring.
        </p>
      </div>

    </section>
  );
}